<template>
  <div class="main">
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`油气费汇总表`)">导出</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"></Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'oil',
      getListUrl: 'detaillist',
      formCtrl: [
        {
          ...this.ctrls.month,
        },
        {
          ...this.ctrls.fleet,
        },
        {
          ...this.ctrls.license,
          label: '车牌号',
        },
      ],
      cols: [
        { keyName: "month", label: "月份" },
        { keyName: "order_num", label: "运单编号" },
        { keyName: "license", label: "车牌号" },
        { keyName: "driver", label: "司机姓名" },
        { keyName: "doil", label: "现金加油金额", align: 'right', className: 'pr30' },
        { keyName: "submit_date", label: "提交日期" },
      ],
      getTotalProperty: [
        'doil_count',
        'doil',
        'moneydoil',
        'summary_doil'
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/finance/oilfeedetails?id=${id}&mode=view`
            );
          },
        },
      ],
      baseParams: [
        'gsid',
        'month',
      ],
    };
  },
  methods: {},
  created() {
    const { user_group_id } = this.user
    if (user_group_id == 1) {
      this.btns[0] = {
        ...this.editBtn,
        cb: ({ id }) => {
          this.$router.push(
            `/finance/oilfeedetails?id=${id}&mode=edit`
          );
        },
      }
    }
  },
  mounted() {
    this.getFleet()
    this.setQueryParams()
    this.MONTH = this.$route.query.month || this.CURR_MONTH
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped>
.main {
  .table-wrap {
    /deep/ .el-table {
      .cell {
        img {
          width: 100%;
          height: 100%;
        }
      }

      .el-image {
        max-height: 50px;
        max-width: 50px;
      }
    }
  }
}
</style>
